import { djxc } from '@/axios'
import { Message } from 'element-ui'
let that = this;
export default{
	data(){
		return{
			pub_time:"",
			title:"",
			content:"",
			imageUrl:"",
			organData:[],
			isUploaded:"上传封面图",
			formData:{
				id:"",
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				title:"",
				img:"",
				type:"",
				// 发布时间
				pub_time:'',
				type1:"1",// 1:党员风采 2:支部风采
				source:"",//来源
				content:"",//图文
				url:""//链接
			},
			types:'图文',
			rules:{
				// 检测标题是否为空
				title: [
					{ required: true, message: '请输入标题', trigger: 'blur' }
				],
				// 检测是否填写党员姓名是否为空
				name: [
					{ required: true, message: '请输入党员姓名', trigger: 'blur' }
				],
				// 检测文本是否为空
				content: [
					{ required: true, message: '请输入内容', trigger: 'blur' }
				],
				// 检测链接是否为空
				url: [
					{ required: true, message: '请输入链接', trigger: 'blur' }
				],
				// 检测分类是否为空
				type1: [
					{ required: true, message: '请选择分类', trigger: 'blur' }
				],
				// 检测分类是否为空
				type: [
					{ required: true, message: '请选择类型', trigger: 'blur' }
				]
			}
		}
	},
	methods:{
		// 获取数据
		getdata(){
			djxc.updateThearGet({
				id:that.$route.query.id,
				type:that.$route.query.fctype,
			}).then(res => {
				if(res.code == 200){
					for(let i in res.data){
						for(let key in that.formData){
							if(i == key){
								that.formData[key] = res.data[i]
							}
						}
					}
					that.imageUrl = res.data.img
				}
			})
		},
		checkData(value){
			// 编辑时检测
			if(that.$route.query.type == 'edit'){
				if(value == '链接'){
					that.formData.content=that.formData.content!=""?that.formData.content:'';
				}else{
					that.formData.url=that.formData.url!=""?that.formData.url:''
				}
			}
		},
		//提交
		submit(){
			that.$refs.formData.validate((valid) => {
				if (valid) {
					if(that.$route.query.type == 'edit'){
						djxc.updateThear(that.formData).then(res => {
							if(res.code == 200){
								Message.success("成功")
								that.$router.go(-1)
							}else{
								Message.error(res.msg)
							}
						})
					}else{
						djxc.addThear(that.formData).then(res => {
							if(res.code == 200){
								Message.success("成功")
								that.$router.go(-1)
							}else{
								Message.error(res.msg)
							}
						})
					}
				} else {
					return false;
				}
			});
		},
		// 上传封面图成功
		success(res, file) {
			if(res.code == 200){
				that.imageUrl = URL.createObjectURL(file.raw);
				that.isUploaded = "重新上传"
				that.formData.img = res.data.src
			}else{
				Message({
					type:"error",
					message:"上传失败，请检查文件或网络连接"
				})
			}
		}
	},
	mounted() {
		if(that.$route.query.type == 'edit'){
			that.getdata();
		}
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	}
}